// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedMicroscopeKinevoStandAddOnWarning_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18 0H16C14.2746 0.00626215 10.9142 0.682044 8.46428 2.9108C5.96936 5.18053 4.00604 8.96689 4.00604 15V17H0V24H2.00302V19H8.01209V24H10.0151V17H6.00907V15C6.00907 9.78104 7.58438 6.63037 9.43902 4.74882C9.50198 4.68496 9.56526 4.62256 9.6288 4.56159C9.69006 4.50281 9.75158 4.44536 9.8133 4.38921C9.99591 4.22308 10.1852 4.06756 10.3793 3.9221C10.5215 3.8156 10.6663 3.71449 10.8131 3.61854C10.875 3.57802 10.9374 3.53842 11 3.49972C12.8411 2.36208 14.9399 2.00542 16 2.00006V4H13.5204L13.7708 6L10.9688 6.00045L10.9653 6.00006L10 9.88221L11.944 10.3641L12.5317 8.00045H14.0212L14.5219 12H19.5295L20.0302 8H21.4683L22.056 10.3637L24 9.88176L23.0347 5.99961L23.0312 6.00048L20.2806 6L20.531 4H18V0ZM17.7642 10H16.2871L15.7864 6H18.265L17.7642 10Z" class="svg-bg"/>
  <path d="M7.62098 1C7.4507 1.13794 7.28301 1.28167 7.11841 1.43141C6.59967 1.90333 6.10652 2.42533 5.64579 3H2V8H3.00967C2.80662 8.63281 2.63125 9.2991 2.48646 10H0V1H7.62098Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM17.771 15.3886L19.7292 14.75V19.6456H17.771V15.3886ZM17.771 20.6246H19.7292V22.5828H17.771V20.6246Z" fill="#FDCA40"/>
  <path d="M17.7715 15.3886 19.7297 14.75V19.6456H17.7715V15.3886ZM17.7715 20.6246H19.7297V22.5828H17.7715V20.6246Z" fill="#1A2329"/>
</svg>
`;
/**
 * IconMedMicroscopeKinevoStandAddOnWarning is a generated icon component.
 */
let IconMedMicroscopeKinevoStandAddOnWarning = IconMedMicroscopeKinevoStandAddOnWarning_1 = class IconMedMicroscopeKinevoStandAddOnWarning extends IconBaseElement {
    render() {
        return html `${IconMedMicroscopeKinevoStandAddOnWarning_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedMicroscopeKinevoStandAddOnWarning.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedMicroscopeKinevoStandAddOnWarning = IconMedMicroscopeKinevoStandAddOnWarning_1 = __decorate([
    customElement('zui-icon-med-microscope-kinevo-stand-add-on-warning')
], IconMedMicroscopeKinevoStandAddOnWarning);
export { IconMedMicroscopeKinevoStandAddOnWarning };
